var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWdfz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1741153652475,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5948,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.722667 64H256A106.666667 106.666667 0 0 0 149.333333 170.666667v682.666666A106.666667 106.666667 0 0 0 256 960h502.528a106.666667 106.666667 0 0 0 106.666667-106.666667V369.792l-0.341334-3.84a21.333333 21.333333 0 0 0-20.992-17.493333l-286.848-0.042667V85.333333a21.333333 21.333333 0 0 0-21.333333-21.333333z m-21.376 42.666667v263.125333l0.384 3.84a21.333333 21.333333 0 0 0 20.992 17.493333l286.762666-0.042666V853.333333a64 64 0 0 1-64 64H256A64 64 0 0 1 192 853.333333V170.666667A64 64 0 0 1 256 106.666667h258.346667z",
    fill: "#ffffff",
    "p-id": 5949
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520.021333 70.826667a21.333333 21.333333 0 0 1 27.093334-3.498667l3.072 2.346667 308.138666 284.416a21.333333 21.333333 0 0 1-25.898666 33.706666l-3.029334-2.346666-308.181333-284.458667a21.333333 21.333333 0 0 1-1.194667-30.122667z",
    fill: "#ffffff",
    "p-id": 5950
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M536.32 64a21.333333 21.333333 0 0 1 20.949333 17.493333l0.341334 3.84v265.045334h286.250666a21.333333 21.333333 0 0 1 20.949334 17.493333l0.384 3.84a21.333333 21.333333 0 0 1-17.493334 20.992l-3.84 0.341333h-307.584a21.333333 21.333333 0 0 1-20.992-17.493333l-0.341333-3.84V85.333333a21.333333 21.333333 0 0 1 21.333333-21.333333zM644.736 632.874667a21.333333 21.333333 0 0 1 3.84 42.325333l-3.84 0.341333H360.277333a21.333333 21.333333 0 0 1-3.84-42.325333l3.84-0.341333h284.458667z",
    fill: "#ffffff",
    "p-id": 5951
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M502.528 490.666667a21.333333 21.333333 0 0 1 20.992 17.493333l0.341333 3.84v284.458667a21.333333 21.333333 0 0 1-42.325333 3.84l-0.341333-3.84V512a21.333333 21.333333 0 0 1 21.333333-21.333333z",
    fill: "#ffffff",
    "p-id": 5952
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdfz);
export default __webpack_public_path__ + "static/media/wdfz.a8eb562f.svg";
export { ForwardRef as ReactComponent };